import { nodeWithArgs, toQuery } from 'common/util/queryHelper';
import { queryGraphQL } from 'common/util/query';
import { loadBinderAction } from 'binder/actions';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';

export const partnerName = {
    VELOS: 'Velos',
    CONNEXUS: 'Connexus',
    IQVIA: 'IQVIA',
};

export const isIntegrationToggleEnabled = (integrations = [], partnerName = '') => {
    const partnerConfig = integrations.find(({ name }) => name === partnerName);
    return (partnerConfig && partnerConfig.enabled) || false;
};

export const subscribeToConnexusStudy = ({ binder }) => async (dispatch) => {
    const { id: binderId, layout: { institutionId }, title, partnerMetadata } = binder;
    const { connexusStudyId, connexusSiteId, connexusSubscribed } = partnerMetadata;
    const updatedPartnerMetadata = {
        ...partnerMetadata,
        connexusSubscribed: connexusSubscribed ? !connexusSubscribed : true,
    };
    const updatedPartnerMetadataStringify = JSON.stringify(updatedPartnerMetadata);
    const query = nodeWithArgs('subscribeToConnexusStudy', {
        binderId,
        binder: {
            partnerMetadata: updatedPartnerMetadataStringify,
            institutionId
        },
    }, [
        'succeeded',
        'error',
    ]);
    const {
        data: {
            subscribeToConnexusStudy: {
                succeeded,
                error,
            }
        }
    } = await queryGraphQL(toQuery(query));
    if (succeeded) {
        const updatedBinder = { ...binder, partnerMetadata: updatedPartnerMetadata};
        updatedBinder.layout = JSON.stringify(updatedBinder.layout);
        dispatch(loadBinderAction({ binder: updatedBinder }));
        dispatch(addApplicationMessage('success', `Successfully connected Connexus Integration Details to ${title}.`));
    } else {
        dispatch(addApplicationMessage('error', error || 
            `Failed to connect Study ID ${connexusStudyId} and Site ID ${connexusSiteId} to ${title}.
            Please make sure the Study ID and Site ID are correct.`
        ));
    }
    return { succeeded };
};

export const unsubscribeToConnexusStudy = ({ binder }) => async (dispatch) => {
    const { id: binderId, layout: { institutionId }, title, partnerMetadata } = binder;
    const { connexusStudyId, connexusSiteId, connexusSubscribed } = partnerMetadata;
    const updatedPartnerMetadata = {
        ...partnerMetadata,
        connexusSubscribed: !connexusSubscribed,
    };
    const updatedPartnerMetadataStringify = JSON.stringify(updatedPartnerMetadata);
    const query = nodeWithArgs('unsubscribeToConnexusStudy', {
        binderId,
        binder: { institutionId, partnerMetadata: updatedPartnerMetadataStringify },
    }, [
        'succeeded',
        'error',
    ]);
    const {
        data: {
            unsubscribeToConnexusStudy: {
                succeeded,
                error,
            }
        }
    } = await queryGraphQL(toQuery(query));
    if (succeeded) {
        const updatedBinder = { ...binder, partnerMetadata: updatedPartnerMetadata };
        updatedBinder.layout = JSON.stringify(updatedBinder.layout);
        dispatch(loadBinderAction({ binder: updatedBinder }));
        dispatch(addApplicationMessage('success', `
            Successfully unsubscribed ${title} from Connexus Study ID ${connexusStudyId} and Site ID ${connexusSiteId}.`
        ));
    } else {
        dispatch(addApplicationMessage('error', error || 
            `Failed to unsubscribe Study ID ${connexusStudyId} and Site ID ${connexusSiteId} from ${title}`
        ));
    }
    return { succeeded };
};
